<div class="cart-container">
  <div class="top">
    <div class="title">
      <span>Your learning cart</span> ({{ courses.length }} items)
    </div>
    <div class="left-and-right" *ngIf="courses && courses.length">
      <div class="left">
        <div class="terms-of-payment">
          Click here to read the <span>Terms of payment!</span>
        </div>
        <div class="courses">
          <table>
            <tr class="table-header">
              <th [style]="{ width: '20%' }">Code</th>
              <th [style]="{ width: '40%' }">Description</th>
              <th [style]="{ width: '10%' }">Price</th>
              <th [style]="{ width: '10%' }">Quantity</th>
              <th [style]="{ width: '15%' }">Total Price</th>
              <th [style]="{ width: '5%' }"></th>
            </tr>
            <tr class="table-body" *ngFor="let course of courses">
              <td [style]="{ width: '20%' }">
                <div class="code-section">
                  <div class="code">#H003</div>
                  <div class="image">
                    <img
                      [src]="
                        getImage(
                          'data:image/jpeg;base64,' + course.thumbnail.buffer
                        )
                      "
                      alt=""
                    />
                  </div>
                </div>
              </td>
              <td [style]="{ width: '40%' }">
                <div class="course-details">
                  <div class="name">{{ course.title }}</div>
                  <div class="description">
                    {{ course.description }}
                  </div>
                </div>
              </td>
              <td [style]="{ width: '10%' }">
                {{ course.price }}
              </td>
              <td [style]="{ width: '10%' }">1</td>
              <td [style]="{ width: '15%' }">
                {{ course.price }}
              </td>
              <td [style]="{ width: '5%' }">
                <div class="delete-icon" (click)="removeFromCart(course)">
                  <i class="fa-solid fa-trash-can"></i>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="right">
        <div class="order-summary">
          <div class="title">Your order summary</div>
          <div class="price-break">
            <div class="flex-between">
              <div>Subtotal</div>
              <div>Rs. {{ totalPrice() }}</div>
            </div>
            <div class="flex-between">
              <div>GST (18%)</div>
              <div>Rs. {{ gstPrice() }}</div>
            </div>
            <div class="flex-between">
              <div class="total">TOTAL</div>
              <div>Rs. {{ totalPrice() + gstPrice() }}</div>
            </div>
          </div>
          <div class="payment-btn">
            <button (click)="onClickPayment()">Proceed to payment</button>
          </div>
        </div>
        <div class="payment-methods">
          <div class="title">Payment methods</div>
          <div class="icons">
            <div class="icon">Paytm</div>
            <div class="icon">GPay</div>
            <div class="icon">PhonePe</div>
            <div class="icon">BHIM</div>
            <div class="icon">Paytm</div>
            <div class="icon">GPay</div>
            <div class="icon">PhonePe</div>
            <div class="icon">BHIM</div>
            <div class="icon">Paytm</div>
            <div class="icon">GPay</div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-message" *ngIf="!courses || courses.length == 0">
      Cart is empty!
    </div>
  </div>

  <div class="bottom">
    <div class="left">
      <div class="label"><span>Still looking?</span> continue learning...</div>
      <div class="btn">
        <button (click)="onClickMoreCourses()">More courses</button>
      </div>
    </div>
    <div class="right">
      <div class="label">Need help? We're listening!</div>
      <div class="phone-number">
        <div class="number1">
          <img src="../../assets/images/icon 12.png" alt="" />
          <div class="text">info@tml.com</div>
        </div>
        <div class="number2">
          <img src="../../assets/images/icon 11.png" alt="" />
          <div class="text">(+91) 11234449 098</div>
        </div>
      </div>
    </div>
  </div>
</div>
